/*
 *  -----------------------------------------------------------------------
 *    <copyright file="tabs.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'hooks';
import './tabs.scss';
import { textToId } from '@utils/automation-test-helpers';
import { AllRoutes } from '@utils/router/all-routes';

const OpraTabs = ({ tabs, style }: any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const getActiveTab = useCallback(() => {
        for (let i = 0; i < tabs.length; ++i) if (tabs[i].active) return i;

        return -1;
    }, [tabs]);

    const [active, setActive] = useState(getActiveTab());

    useEffect(() => {
        if (tabs) setActive(getActiveTab());
    }, [tabs, getActiveTab]);

    if (!tabs || !tabs.length) return null;

    return (
        <Tabs
            value={active >= 0 ? active : 0}
            style={style}
            onChange={(e: any, newValue: any) => {
                if (tabs[newValue].link) navigate(AllRoutes.path(tabs[newValue].link));
                else setActive(newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            centered
        >
            {tabs.map((tab: any, index: any) => (
                <Tab
                    key={tab.id}
                    id={tab.id}
                    disabled={tab.disabled}
                    className={active === index ? 'selected-tab' : 'unselected-tab'}
                    label={tab.text[0] === '@' ? tab.text.substr(1) : t(tab.text)}
                    data-testid={`tab-${textToId(tab.text, index)}`}
                />
            ))}
        </Tabs>
    );
};

export default OpraTabs;
